import {Box, Button, Link, Typography} from "@mui/material"
import React from "react"
import {useNavigate} from "react-router-dom"
import {
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL
} from "data/constants/support"

// Design tokens per the Benefits2 Screen Fixes brief. These are hard-coded for
// now; when the central MUI theme lands they should become theme palette /
// button variants (Logo Blue primary, Navy outline secondary).
const LOGO_BLUE = "#2663E5"
const NAVY = "#0F1E4E"

interface EligibilityErrorScreenProps {
  onTryAgain: () => void
  title?: string
  message?: string
}

export const EligibilityErrorScreen: React.FC<EligibilityErrorScreenProps> = (
  props: EligibilityErrorScreenProps
) => {
  const {
    onTryAgain,
    title = "We're having trouble loading your payment options.",
    message = "Your answers have been saved. Please try again in a moment."
  } = props
  const navigate = useNavigate()

  const onReturnHome = () => {
    navigate("/")
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
      minHeight="480px"
      paddingX={{xs: 3, sm: 6}}
      paddingY={6}
      gap={3}
    >
      <Box maxWidth="640px">
        <Typography
          component="h1"
          fontWeight="bold"
          fontSize="24px"
          color={NAVY}
          gutterBottom
        >
          {title}
        </Typography>
        <Typography component="p" fontSize="18px" color={NAVY}>
          {message}
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection={{xs: "column", sm: "row"}}
        gap={2}
        width={{xs: "100%", sm: "auto"}}
      >
        <Button
          onClick={onTryAgain}
          variant="contained"
          disableElevation
          sx={{
            backgroundColor: LOGO_BLUE,
            color: "#FFFFFF",
            minHeight: "48px",
            minWidth: "200px",
            borderRadius: "20px",
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "none",
            "&:hover": {backgroundColor: "#1f52c0"}
          }}
        >
          Try Again
        </Button>
        <Button
          onClick={onReturnHome}
          variant="outlined"
          sx={{
            color: NAVY,
            borderColor: NAVY,
            minHeight: "48px",
            minWidth: "200px",
            borderRadius: "20px",
            fontSize: "16px",
            fontWeight: "bold",
            textTransform: "none",
            "&:hover": {
              borderColor: NAVY,
              backgroundColor: "rgba(15, 30, 78, 0.04)"
            }
          }}
        >
          Return to Dashboard
        </Button>
      </Box>

      <Typography component="p" fontSize="16px" color={NAVY}>
        Still having trouble? Email{" "}
        <Link href={`mailto:${SUPPORT_EMAIL}`} sx={{color: LOGO_BLUE}}>
          {SUPPORT_EMAIL}
        </Link>{" "}
        or call/text{" "}
        <Link href={`tel:${SUPPORT_PHONE_TEL}`} sx={{color: LOGO_BLUE}}>
          {SUPPORT_PHONE}
        </Link>
        .
      </Typography>
    </Box>
  )
}

export default EligibilityErrorScreen
